import React from "react"

const TicketActivity = ({
    contentHtml
}) => {
    return (
        <div>
            <div
                dangerouslySetInnerHTML={{ __html: contentHtml }}
                style={{ whiteSpace: 'pre-line' }}
            ></div>
        </div>
    )
}

export default TicketActivity